import React from 'react';
import { SecurityGrant } from './framework.core/SecurityGrant';

import { User, SystemSettings, SuntekSettings } from './ifmsTypes';
import { ControlType } from './fms.core/modules/FmsSecurity';
import { FormType } from './fms.enum';

export interface IApplicationContext {
  api: any|null,
  user:User|null,
  systemSettings:SystemSettings|null|undefined,
  setSystemSettings: (s:Partial<SystemSettings>) => void,
  suntekSettings:SuntekSettings|null|undefined,   //<pt211201>
  setSuntekSettings: (s:Partial<SuntekSettings>) => void,
  defaultPageSize: number,
  // journalType : number,
  // setJournalType:(x:number) => void,
  onLogout: () => void
  refreshSystemSettings: () => Promise<void>,
  securityGrants: SecurityGrant[]|null|undefined,
  appInfoAreaContent:string,
  setAppInfoAreaContent:(x:string) => void,
  appInfoAreaDrawerHeight:number,
  setUseDarkMode:(x:boolean) => void,
  useDarkMode:boolean,
  backgroundColor: string,
  setBackgroundColor : (x:string) => void,
  setAppInfoAreaDrawerHeight:(x:number) => void,
  securityControls: Record<string, ControlType[]>|null|undefined,
  setSecurityControls: (j:string, c:ControlType[]) => void,
  getControlDisableStatus: (j: string, c: string, f: FormType) => boolean,
  logoutWorker: Worker|null,
  myMemoTaskReminder:boolean,
  setMyMemoTaskReminder: (x:boolean) => void,
 // setUseCheckReminder:(x:boolean) => void,
 // useCheckReminder:boolean,
  myMemoId: number,
  setMyMemoId: (x:number) => void,
  showReminderPop: any,
  setShowReminderPop: (x: any) => void,
  openMemoDetail: boolean,
  setOpenMemoDetail: (x: boolean) => void,
  useOrchid: boolean,
  setUseOrchid:(x:boolean) => void,
  logoImg: string
  setLogoImg:(x:string) => void,
  logoName: string
  setLogoName:(x:string) => void,
  enableTaskBoard:boolean,
  setEnableTaskBoard: (x: boolean) => void,
  defaultSearchOption: string,
  setDefaultSearchOption: (x: string) => void,
};

const defaultState:IApplicationContext = {
  api: undefined,
  user: null,
  systemSettings: null,
  setSystemSettings: () => {},
  suntekSettings: null,   //<pt211201>
  setSuntekSettings: () => { },
  defaultPageSize: 50,
  // journalType: 0,
  // setJournalType: () => { },
  onLogout: () => { },
  refreshSystemSettings: async () => {},
  securityGrants: null,
  appInfoAreaContent: 'none',
  setAppInfoAreaContent: () => {},
  appInfoAreaDrawerHeight: 0,
  setAppInfoAreaDrawerHeight: () => {},
  useDarkMode: false,
  setUseDarkMode: () => {},
  backgroundColor: 'A',
  setBackgroundColor:() => {},
  securityControls: null,
  setSecurityControls:  () => {},
  getControlDisableStatus: () => false,
  logoutWorker: null,
  myMemoTaskReminder: false,
  setMyMemoTaskReminder:()=>{},
  //useCheckReminder: false,
  //setUseCheckReminder: ()=>{},
  myMemoId: 0,
  setMyMemoId:()=>{},
  showReminderPop: false,
  setShowReminderPop: ()=>{},
  openMemoDetail: false,
  setOpenMemoDetail: () => {},
  useOrchid: false,
  setUseOrchid:() => {},
  logoImg: '',
  setLogoImg:() => {},
  logoName: '',
  setLogoName:() => {},
  enableTaskBoard: false,
  setEnableTaskBoard: () => {},
  defaultSearchOption: 'C',
  setDefaultSearchOption: () => {},
};

const ApplicationContext = React.createContext<IApplicationContext>(defaultState);

export default ApplicationContext;
